import { css } from '@emotion/react';

export const personalOfferStyles = css`
  .personal-offer {
    display: flex;
    flex-direction: column;

    div {
      strong {
        display: inline-block;
        margin-left: 2.3rem;
      }
    }

    section {
      font-size: 14px;
      line-height: 1.33;
      display: flex;
      flex: 0 1 100%;
      justify-content: space-between;
    }

    article {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      margin-bottom: 20px;

      h2 {
        font-size: 30px;
        margin: 0 0 30px;

        &::after {
          content: '';
          display: block;
          margin-top: 30px;
          margin-bottom: 30px;
          width: 100px;
          height: 2px;
          background: #000;
        }
      }

      span {
        display: inline-flex;
        flex-grow: 0;
        flex-shrink: 0;
        font-size: 1rem;

        flex-basis: 3.5rem;
        opacity: 0.6;
      }

      p {
        display: inline;
        margin: 0;
      }

      &[data-head='head'] {
        /* stylelint-disable-line */
        display: block;
        margin-bottom: 4rem;

        p {
          display: block;
          margin-bottom: 15px;
        }
      }

      &:lang(en) {
        width: 100%;
      }

      &:lang(ru) {
        display: none;
        margin-left: 5%;
        width: 100%;
      }
    }
  }
`;
